import { find } from "lodash";

const getProductFromCart = (cart: Cart|null, productId: number) => (
    find(cart?.products, product => product.id === productId) ?? null
);

export {
    getProductFromCart
};